import { Directive, forwardRef, ElementRef, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: 'adc-text-input, adc-select, adc-auto-complete',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AileronFormElementDirective),
            multi: true
        }
    ]
})
export class AileronFormElementDirective implements ControlValueAccessor {
    onChange: any = () => {};
    onTouched: any = () => {};

    private _value: number;

    get value() {
        return this._value;
    }

    set value(val) {
        if (val !== this._value) {
            this._value = val;
            this.onChange(this._value);
            this.onTouched();
            this.elementRef.nativeElement.value = val;
        }
    }

    constructor(private elementRef: ElementRef) {
    }

    @HostListener('blur', ['$event'])
    listenForValueChange(ev) {
        if (ev.target.adcTextInput) {
            this.value = ev.target.adcTextInput.value
        } else if (ev.target) {
            this.value = ev.target.value
        }
    }

    writeValue(value) {
        if (value) {
            this.value = value;
        }
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }
}
